import type { Partner } from '@sshop/domain';

import { parseDto } from '../../mappers/parseDto';
import type { Transport } from '../../transport/Transport';

import { partnerListDto } from './partner.dto';

export interface PartnerService {
  list(signal?: AbortSignal): Promise<readonly Partner[]>;
}

export function createLaravelPartnerService(transport: Transport): PartnerService {
  return {
    async list(signal): Promise<readonly Partner[]> {
      const res = await transport.request({
        method: 'GET',
        path: '/partners',
        ...(signal !== undefined ? { signal } : {}),
      });
      const parsed = parseDto(partnerListDto, res.data, 'GET /partners');
      return parsed.data.map((p) => ({
        id: p.id,
        name: p.name,
        brandOptionId: p.brand_option_id,
        logo: p.logo,
      }));
    },
  };
}
